import React, { useEffect, useState } from "react";
import UploadDocument from "./UploadDocument";
import useCloudinaryWidget from "../hooks/useCloudinary";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchDocuments,
  deleteDocument,
  createDocument,
  updateDocument,
} from "../store/slices/document";
import { toast } from "react-toastify";

const JobSeekerDocuments = () => {
  const dispatch = useDispatch();
  const { uploadToCloudinary } = useCloudinaryWidget();
  const { documents } = useSelector((state) => state.document);
  const { token } = useSelector((state) => state.auth);
  const { job_seeker } = useSelector((state) => state?.jobSeeker);

  const [loading, setLoading] = useState(null);

  const handleFileUpload = async (id, type) => {
    try {
      setLoading(id);
      const { url, fileName } = await uploadToCloudinary();

      // Create or update the document
      let values = {};
      if (id === undefined) {
        values = {
          job_seeker_id: job_seeker.id,
          document_name: fileName ? fileName : "File Name not found",
          document_type: type,
          document_url: url,
          document_owner: "job_seeker",
        };

        if (url) {
          dispatch(createDocument(values));
        }
      } else {
        values = {
          document_name: fileName ? fileName : "File Name not found",
          document_url: url,
        };
        if (url) {
          dispatch(updateDocument({ id, values }));
        }
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(null);
    }
  };

  // Delete a document
  const handleDelete = (id) => {
    dispatch(deleteDocument(id));
  };

  useEffect(() => {
    dispatch(fetchDocuments({ token, jobseeker_id: job_seeker.id }));
  }, []);

  // separate the documents into their respective types
  const businessLicenseDocument = documents.find(
    (doc) => doc.document_type === "resume"
  );
  const coiDocument = documents.find(
    (doc) => doc.document_type === "cover_letter"
  ); //certificate of incoporation
  const otherDocument = documents.find((doc) => doc.document_type === "others");

  return (
    <div className="p-8 max-sm:p-2 max-sm:w-full">
      <h1 className="text-xl font-semibold text-gray-500 mb-8">
        Required Documents
      </h1>

      {/* File Upload Section */}
      <section>
        <div className="block rounded-lg shadow-lg bg-white p-8 max-sm:p-2 __joyride_upload_docs">
          <UploadDocument
            loading={loading === businessLicenseDocument?.id}
            title={"Resume"}
            fileName={businessLicenseDocument?.document_name}
            onClick={() =>
              handleFileUpload(businessLicenseDocument?.id, "resume")
            }
            handleDelete={() => handleDelete(businessLicenseDocument?.id)}
          />
          <UploadDocument
            loading={loading === coiDocument?.id}
            title={"Cover Letter"}
            fileName={coiDocument?.document_name}
            onClick={() => handleFileUpload(coiDocument?.id, "cover_letter")}
            handleDelete={() => handleDelete(coiDocument?.id)}
          />
          <UploadDocument
            loading={loading === otherDocument?.id}
            title={"Other Documents"}
            fileName={otherDocument?.document_name}
            onClick={() => handleFileUpload(otherDocument?.id, "others")}
            handleDelete={() => handleDelete(otherDocument?.id)}
          />
        </div>
      </section>
    </div>
  );
};

export default JobSeekerDocuments;
